/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Flex,
  Grid,
  SwitchField,
  TextField,
} from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { generateClient } from "aws-amplify/api";
import { getDestination } from "../graphql/queries";
import { updateDestination } from "../graphql/mutations";
const client = generateClient();
export default function DestinationUpdateForm(props) {
  const {
    id: idProp,
    destination: destinationModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    languageId: "",
    countryId: "",
    cityId: "",
    pointOfInterestId: "",
    isActive: false,
  };
  const [languageId, setLanguageId] = React.useState(initialValues.languageId);
  const [countryId, setCountryId] = React.useState(initialValues.countryId);
  const [cityId, setCityId] = React.useState(initialValues.cityId);
  const [pointOfInterestId, setPointOfInterestId] = React.useState(
    initialValues.pointOfInterestId
  );
  const [isActive, setIsActive] = React.useState(initialValues.isActive);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = destinationRecord
      ? { ...initialValues, ...destinationRecord }
      : initialValues;
    setLanguageId(cleanValues.languageId);
    setCountryId(cleanValues.countryId);
    setCityId(cleanValues.cityId);
    setPointOfInterestId(cleanValues.pointOfInterestId);
    setIsActive(cleanValues.isActive);
    setErrors({});
  };
  const [destinationRecord, setDestinationRecord] =
    React.useState(destinationModelProp);
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? (
            await client.graphql({
              query: getDestination.replaceAll("__typename", ""),
              variables: { id: idProp },
            })
          )?.data?.getDestination
        : destinationModelProp;
      setDestinationRecord(record);
    };
    queryData();
  }, [idProp, destinationModelProp]);
  React.useEffect(resetStateValues, [destinationRecord]);
  const validations = {
    languageId: [],
    countryId: [],
    cityId: [],
    pointOfInterestId: [],
    isActive: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          languageId: languageId ?? null,
          countryId: countryId ?? null,
          cityId: cityId ?? null,
          pointOfInterestId: pointOfInterestId ?? null,
          isActive: isActive ?? null,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await client.graphql({
            query: updateDestination.replaceAll("__typename", ""),
            variables: {
              input: {
                id: destinationRecord.id,
                ...modelFields,
              },
            },
          });
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "DestinationUpdateForm")}
      {...rest}
    >
      <TextField
        label="Language id"
        isRequired={false}
        isReadOnly={false}
        value={languageId}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              languageId: value,
              countryId,
              cityId,
              pointOfInterestId,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.languageId ?? value;
          }
          if (errors.languageId?.hasError) {
            runValidationTasks("languageId", value);
          }
          setLanguageId(value);
        }}
        onBlur={() => runValidationTasks("languageId", languageId)}
        errorMessage={errors.languageId?.errorMessage}
        hasError={errors.languageId?.hasError}
        {...getOverrideProps(overrides, "languageId")}
      ></TextField>
      <TextField
        label="Country id"
        isRequired={false}
        isReadOnly={false}
        value={countryId}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              languageId,
              countryId: value,
              cityId,
              pointOfInterestId,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.countryId ?? value;
          }
          if (errors.countryId?.hasError) {
            runValidationTasks("countryId", value);
          }
          setCountryId(value);
        }}
        onBlur={() => runValidationTasks("countryId", countryId)}
        errorMessage={errors.countryId?.errorMessage}
        hasError={errors.countryId?.hasError}
        {...getOverrideProps(overrides, "countryId")}
      ></TextField>
      <TextField
        label="City id"
        isRequired={false}
        isReadOnly={false}
        value={cityId}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              languageId,
              countryId,
              cityId: value,
              pointOfInterestId,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.cityId ?? value;
          }
          if (errors.cityId?.hasError) {
            runValidationTasks("cityId", value);
          }
          setCityId(value);
        }}
        onBlur={() => runValidationTasks("cityId", cityId)}
        errorMessage={errors.cityId?.errorMessage}
        hasError={errors.cityId?.hasError}
        {...getOverrideProps(overrides, "cityId")}
      ></TextField>
      <TextField
        label="Point of interest id"
        isRequired={false}
        isReadOnly={false}
        value={pointOfInterestId}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              languageId,
              countryId,
              cityId,
              pointOfInterestId: value,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.pointOfInterestId ?? value;
          }
          if (errors.pointOfInterestId?.hasError) {
            runValidationTasks("pointOfInterestId", value);
          }
          setPointOfInterestId(value);
        }}
        onBlur={() =>
          runValidationTasks("pointOfInterestId", pointOfInterestId)
        }
        errorMessage={errors.pointOfInterestId?.errorMessage}
        hasError={errors.pointOfInterestId?.hasError}
        {...getOverrideProps(overrides, "pointOfInterestId")}
      ></TextField>
      <SwitchField
        label="Is active"
        defaultChecked={false}
        isDisabled={false}
        isChecked={isActive}
        onChange={(e) => {
          let value = e.target.checked;
          if (onChange) {
            const modelFields = {
              languageId,
              countryId,
              cityId,
              pointOfInterestId,
              isActive: value,
            };
            const result = onChange(modelFields);
            value = result?.isActive ?? value;
          }
          if (errors.isActive?.hasError) {
            runValidationTasks("isActive", value);
          }
          setIsActive(value);
        }}
        onBlur={() => runValidationTasks("isActive", isActive)}
        errorMessage={errors.isActive?.errorMessage}
        hasError={errors.isActive?.hasError}
        {...getOverrideProps(overrides, "isActive")}
      ></SwitchField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || destinationModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || destinationModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
